import { Pipe, PipeTransform, TemplateRef } from '@angular/core';
import { mergeSlaSummaryTemplates } from '../../helpers/sla-summary-column/sla-summary-column.helper';

/** Swaps the SLA / remaining time cell templates for the combined SLA cell. */
@Pipe({
  name: 'slaSummaryTemplates',
  standalone: true,
})
export class SlaSummaryTemplatesPipe implements PipeTransform {
  transform<T extends { identifier?: string; template: TemplateRef<unknown> }>(
    value: T[] | null | undefined,
    enabled: boolean,
    summaryTemplate: TemplateRef<unknown>
  ): T[] {
    return mergeSlaSummaryTemplates(value ?? [], enabled, summaryTemplate);
  }
}
